import { CRL_DOMAIN } from 'src/constants';

export enum MEDIA_TYPE {
  IMAGE = 'image',
  VIDEO = 'video',
  PDF = 'pdf',
  SUBTITLES = 'subtitle',
}

export const MAIN_DESKTOP_IMAGE_ROOT = `${CRL_DOMAIN}/credits/locale/en-us/resource-type/image/variation/desktop`;
export const MAIN_MOBILE_IMAGE_ROOT = `${CRL_DOMAIN}/credits/locale/en-us/resource-type/image/variation/mobile`;

/**
 * This will provide the prefix for an image url in the content resource library associated with this environment stage.
 * @param isSmallDesktop whether this is a small desktop or not
 */
export const getImageRoot = (isSmallDesktop: boolean): string =>
  isSmallDesktop ? MAIN_DESKTOP_IMAGE_ROOT : MAIN_MOBILE_IMAGE_ROOT;

export const getCreditsAssetRoot = (isSmallDesktop: boolean, mediaType: MEDIA_TYPE): string => {
  const basePath = `${CRL_DOMAIN}/credits/locale/en-us/resource-type`;

  if (mediaType === MEDIA_TYPE.PDF) {
    return `${basePath}/${mediaType}`;
  }

  if (mediaType === MEDIA_TYPE.SUBTITLES) {
    return `${basePath}/${MEDIA_TYPE.VIDEO}/${mediaType}`;
  }

  const assetVariant = isSmallDesktop ? 'desktop' : 'mobile';
  return `${basePath}/${mediaType}/variation/${assetVariant}`;
};
